<template>
  <div>
    <page-header :title="$tc('qr_code', 2)" />
    <page-content>
      <div v-if="loading" class="text-center py-6">
        <i class="fa fa-spinner fa-spin fa-2x"></i>
      </div>
      <template v-else>
        <div class="website-hero">
          <div class="website-hero-label">Website</div>
          <div class="website-hero-url">{{ getWebsiteDomain() }}</div>
          <div class="d-flex align-items-center justify-content-center mt-3" style="gap: 12px;">
            <button type="button" class="btn btn-circle btn-info" v-tooltip="$t('tooltip.copyLink')" @click="copyToClipboard(getWebsiteDomain())">
              <i class="fa fa-copy"></i>
            </button>
            <le-qr-code name="website" :link="getWebsiteDomain()" btn-size=""></le-qr-code>
          </div>
        </div>
        <ntm-block :collapsable="false">
          <div class="table-responsive">
            <table class="table table-bordered table-striped table-vcenter">
              <thead>
                <tr>
                  <th>{{ $t('table.column.venue') }}</th>
                  <th v-for="link in linkTypes" :key="link.key" class="text-center">{{ $t(link.labelKey) }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="venue in venues" :key="venue.uuid">
                  <td class="font-w600">{{ venue.name }}</td>
                  <td v-for="link in linkTypes" :key="link.key" class="text-center">
                    <button
                      type="button"
                      class="btn btn-sm btn-circle btn-info mr-2"
                      v-tooltip="$t('tooltip.copyLink')"
                      @click="copyToClipboard(getLinkUrl(venue, link))"
                    >
                      <i class="fa fa-copy"></i>
                    </button>
                    <le-qr-code :name="venue.name" :link="getLinkUrl(venue, link)"></le-qr-code>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </ntm-block>
      </template>
    </page-content>
  </div>
</template>

<script>
import VenueService from '@/services/venue.service'
import { useExternalLinks } from '@/use/useExternalLinks'

export default {
  name: 'QrCode',
  setup () {
    const { getWebsiteDomain } = useExternalLinks()
    return { getWebsiteDomain }
  },
  data () {
    return {
      venues: [],
      loading: true,
      linkTypes: [
        { key: 'broadcast', labelKey: 'table.column.livestreamWidget', method: 'broadcastWidgetLink' },
        { key: 'teamStatsOverlay', labelKey: 'table.column.teamStatsOverlayLink', method: 'teamStatsOverlayLink' },
        { key: 'scoreboard', labelKey: 'table.column.scoreboardLink', method: 'scoreboardLink' },
        { key: 'playerStats', labelKey: 'table.column.playerStatsLink', method: 'playerStatsLink' },
        { key: 'livestream', labelKey: 'table.column.livestreamLink', method: 'livestreamLink' },
        { key: 'shotClock', labelKey: 'table.column.shotClockLink', method: 'shotClockLink' },
        { key: 'liveGame', labelKey: 'table.column.liveGameWebsiteLink', method: 'liveGameWebsiteLink' }
      ]
    }
  },
  mounted () {
    VenueService.index('', 1, 1000).then((response) => {
      this.venues = response.data.data
      this.loading = false
    })
  },
  methods: {
    broadcastWidgetLink (venue) {
      return `${this.getWebsiteDomain()}/venues/${venue.uuid}/broadcast-game`
    },
    teamStatsOverlayLink (venue) {
      return `${this.getWebsiteDomain()}/venues/${venue.uuid}/team-stats-overlay`
    },
    scoreboardLink (venue) {
      return `${this.getWebsiteDomain()}/venues/${venue.uuid}/scoreboard-game`
    },
    playerStatsLink (venue) {
      return `${this.getWebsiteDomain()}/venues/${venue.uuid}/player-stats`
    },
    livestreamLink (venue) {
      return `${this.getWebsiteDomain()}/venues/${venue.uuid}/livestream`
    },
    shotClockLink (venue) {
      return `${this.getWebsiteDomain()}/venues/${venue.uuid}/shot-clock-game`
    },
    liveGameWebsiteLink (venue) {
      return `${this.getWebsiteDomain()}?venue=${venue.uuid}`
    },
    getLinkUrl (venue, link) {
      return this[link.method](venue)
    },
    copyToClipboard (text) {
      this.$copyText(text).then(() => {
        this.$toast.fire({
          title: 'Copied to clipboard',
          icon: 'success'
        })
      })
    }
  }
}
</script>

<style scoped>
.website-hero {
  text-align: center;
  padding: 36px 24px;
  margin-bottom: 24px;
  background: #fff;
  border-radius: 8px;
  border: 2px solid #008078;
}
.website-hero-label {
  font-size: 13px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: #008078;
  margin-bottom: 6px;
}
.website-hero-url {
  font-size: 22px;
  font-weight: 700;
  color: #2c2c2c;
}

.table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.table-responsive table {
  min-width: 100%;
}

.table-responsive td,
.table-responsive th {
  white-space: nowrap;
  padding: 0.75rem;
}

.table-responsive td > button,
.table-responsive td > div {
  display: inline-block;
  vertical-align: middle;
}
</style>
